// extracted by mini-css-extract-plugin
export default {"countrycard-container":"CountryCard_countrycard-container__7VDhY"};